import { Typography } from "@packages/ds";
import styled from "styled-components";

import * as Dropdown from "ds/Dropdown";
import * as Sticker from "ds/Sticker";
import * as Table from "ds/Table";

export const StickerRoot = styled(Sticker.Root)`
  margin-bottom: 32px;
`;

export const StyledTable = styled(Table.Table)`
  margin-top: 16px;
`;

export const BodyText = styled(Typography.BodyText)`
  display: flex;
  gap: 20px;
`;

export const DropdownTrigger = styled(Dropdown.Trigger)`
  margin-left: auto;
`;
